// Vap House: asegura el botón "Pagar con Transferencia" de Scala Discounts en el carrito (01-10).
// La app lo inyecta una sola vez al cargar la página: si el carrito estaba vacío, o el cajón se re-renderiza
// (agregar, cambiar cantidad), el botón no aparece. Y sin ese botón el 20% es inalcanzable: es el que marca el
// carrito con _scaladiscount=1 antes de ir al checkout. Acá, ya inicializada la app, se crea el elemento junto al
// botón de pago; su connectedCallback lo engancha solo. Visualmente va debajo del botón de pago (order en cart-summary).
if (!window.__vhScala) {
  window.__vhScala = true;
  const asegurar = () => {
    if (!customElements.get('scala-cart-button')) return;
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const pagar = ctas.querySelector('.cart__checkout-button');
      if (!pagar || pagar.disabled) return;
      const cont = ctas.parentElement;
      const ya = cont.querySelector('scala-cart-button');
      if (ya) return;   // la ubicación debajo del botón de pago la resuelve el CSS (order), sin mover nodos
      try { ctas.after(document.createElement('scala-cart-button')); } catch (e) { console.warn('vh-scala', e); }
    });
  };
  let t = 0;
  const programar = () => { clearTimeout(t); t = setTimeout(asegurar, 250); };
  customElements.whenDefined('scala-cart-button').then(() => {
    setTimeout(asegurar, 1200);   // después del attachButtons propio de la app
    new MutationObserver(programar).observe(document.body, { childList: true, subtree: true });
  });
}
